import { render, staticRenderFns } from "./Movimiento-de-stock.vue?vue&type=template&id=0de552d6"
import script from "./Movimiento-de-stock.vue?vue&type=script&lang=js"
export * from "./Movimiento-de-stock.vue?vue&type=script&lang=js"
import style0 from "./Movimiento-de-stock.vue?vue&type=style&index=0&id=0de552d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports